import axios from "axios";

const API_PATH = '/manage/business/members';

const FetchSource = async searches => (
	await axios.get(API_PATH, { params: searches })
);

const FetchMemberView = async ({ id }) => (
	await axios.get(`${API_PATH}/${id}`)
);

const FetchMemberExercise = async ({ id, source }) => (
	await axios.get(`${API_PATH}/${id}/exercise`, { params: source })
);

const FetchMemberPointHistory = async ({ id, source }) => (
	await axios.get(`${API_PATH}/${id}/points/history`, { params: source })
);

const FetchApplyingSource = async searches => (
	await axios.get(`${API_PATH}/applying`, { params: searches })
);

const MemberReview = async ({ mId, source }) => (
	await axios.put(`${API_PATH}/${mId}/review`, source)
);

const MemberMultipleReview = async source => (
	await axios.put(`${API_PATH}/multiple-review`, source)
);

const RemoveBusinessMember = async mId => (
	await axios.delete(`${API_PATH}/${mId}`)
);

const ImportBusinessMember = async source => (
	await axios.post(`${API_PATH}/csv/import`, source, {headers: { 'Content-Type': 'multipart/form-data' }})
);

export { FetchSource, FetchMemberView, FetchMemberExercise, FetchMemberPointHistory, FetchApplyingSource, MemberReview, MemberMultipleReview, RemoveBusinessMember, ImportBusinessMember } ;
